import React from "react"
import { Row, Col } from "reactstrap"
import styles from "./ViewToggleTabs.module.scss"

const ViewToggleTabs = ({ tabs, activeTab, setActiveTab }) => {
  return (
    <Row className="gx-2">
      {tabs.map((tab) => (
        <Col key={tab.id}>
          <div
            className={`${styles.tab} ${activeTab === tab.id ? styles.active : ""}`}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.icon} {tab.label}
          </div>
        </Col>
      ))}
    </Row>
  )
}

export default ViewToggleTabs
